/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Someone who asked for a server, and why.
 */
export type ApprovalRequester = {
  /**
   * The requester's justification. The one input no automated evidence supplies.
   */
  note?: string | undefined;
  /**
   * When they asked.
   */
  requestedAt: Date;
  /**
   * The requester's email, when known.
   */
  userEmail?: string | undefined;
  /**
   * The requester.
   */
  userId: string;
};

/** @internal */
export const ApprovalRequester$inboundSchema: z.ZodMiniType<
  ApprovalRequester,
  unknown
> = z.pipe(
  z.object({
    note: z.optional(z.string()),
    requested_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_email: z.optional(z.string()),
    user_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "requested_at": "requestedAt",
      "user_email": "userEmail",
      "user_id": "userId",
    });
  }),
);

export function approvalRequesterFromJSON(
  jsonString: string,
): SafeParseResult<ApprovalRequester, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApprovalRequester$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApprovalRequester' from JSON`,
  );
}
